import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONSTANTS from './ActionConstants';
import UserViewData, { IUserViewData } from "../../models/user/UserViewData";
import IUserFormData, { userPostData } from "../../models/user/UserFormData";
import notificationActions from "./NotificationActions";
import { IApiResponse } from "../../utilities/ApiResponse";
import * as CONSTANTS from "../../utilities/Constants";
import i18next from "i18next";

class UserActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONSTANTS.AUTH_ENDPOINT);
    }

    async getById(id: string) {
        try {
            const request = new ApiRequest("/User/" + id, "", null, i18next.t("User not found."));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.USER_GET_BY_ID,
                payload: {
                    userData: payload
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async getAll() {
        try {
            const request = new ApiRequest("/Users", "", null, i18next.t("Internal server error!"));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.USER_GET_ALL,
                payload: {
                    userDataList: payload
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async getAllRoles() {
        try {
            const request = new ApiRequest("/Roles", "", null, i18next.t("Internal server error!"));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.GET_ALL_USER_ROLES,
                payload: {
                    userRoleList: payload
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async post(data: userPostData): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(data);
            const request = new ApiRequest("/User", "", payload, i18next.t("User created."));
            const result = await this.api.post(request);
            this.TriggerSuccessNotifications(result);
            setTimeout(() => {
                LMSDispatcher.dispatch({
                    type: ACTIONCONSTANTS.USER_CREATE,
                    payload: {
                        data: result.data
                    }
                });
            }, 2000);
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async put(data: userPostData): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(data);
            console.log(payload, "payload");
            const request = new ApiRequest("/User/" + data.userFormData.id, "", payload, i18next.t("User updated."));
            const result = await this.api.put(request);
            setTimeout(() => {
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.USER_SUBMIT,
                payload: {
                    data: result
                }
            });
            }, CONSTANTS.NOTIFICATION_TIMEOUT);
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    async changePassword(data: any, id: string): Promise<void> {
        try {
            const payload: any = data;
            const request = new ApiRequest("/resetPassword/" + id, "", payload, i18next.t("password updated Successfully."));
            const result = await this.api.put(request);
            this.TriggerSuccessNotifications(result);
            setTimeout(() => {
            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.PASSWORD_CHANGE,
                payload: {
                    data: result
                }
            });
            }, CONSTANTS.NOTIFICATION_TIMEOUT);
        } catch (error) {
            let errorMessage = i18next.t("Password validation failed")
            if(data.newPasssowrd === data.confirmPasssowrd){
                errorMessage = i18next.t("Old and new Password Can't be same!")
            }
            if(data.newPasssowrd !== data.confirmPasssowrd){
                errorMessage = i18next.t("Password and confirm password should be same!")
            }
            notificationActions.show({
                severity: "alarm",
                message: errorMessage
            }).then();
        }
    }

    async delete(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/User/" + id, requestId, undefined, i18next.t("User deleted."));
            const result = await this.api.delete(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONSTANTS.USER_DELETE,
                payload: {
                    reload: true
                }
            });
        } catch (error) {
            notificationActions.show({
                severity: "alarm",
                message: error.message
            }).then();
        }
    }

    private TriggerSuccessNotifications(result: IApiResponse) {
        if (result.message) {
            result.message.forEach(async (item: any) => {
                await notificationActions.show({
                    severity: "success",
                    message: item
                });
            });
        }
    }

    private preparePostPayload(data: userPostData): any {
        const userData = data.userFormData;
        const clientRoleData = data.roleData.clientRoles[0];
        const realmRoleData = data.roleData.realmRoles[0];
        return {
            user: {
              enabled: "true",
              firstName: userData.firstName,
              lastName: userData.lastName,
              email: userData.email,
              username: userData.username
            },
            userCredentials: {
              type: "password",
              value: userData.password,
              temporary: true
            },
            changeRoleRequest: {
              clientRole: {
                oldRoles: [],
                newRoles: [
                    {
                        id: clientRoleData.id,
                        name: clientRoleData.name,
                        composite: clientRoleData.composite,
                        clientRole: clientRoleData.clientRole,
                        containerId: clientRoleData.containerId
                    }
                ]
              },
              realmRole: {
                oldRoles: [],
                newRoles: [
                    {
                        id: realmRoleData.id,
                        name: realmRoleData.name,
                        composite: realmRoleData.composite,
                        clientRole: realmRoleData.clientRole,
                        containerId: realmRoleData.containerId
                    }
                ]
              }
            }
        }
    }

    private preparePutPayload(data: userPostData): any {
        const userData = data.userFormData;
        const clientRoleData = data.roleData.hasOwnProperty('clientRoles') ? data.roleData.clientRoles[0] : [];
        const realmRoleData = data.roleData.hasOwnProperty('realmRoles') ? data.roleData.realmRoles[0] : [];
        const oldClientRoleData = data.oldRoleData.hasOwnProperty('clientRoles') ? data.oldRoleData.clientRoles[0] : [];
        const oldRealmRoleData = data.oldRoleData.hasOwnProperty('realmRoles') ? data.oldRoleData.realmRoles[0] : [];
        return {
            user: {
              id: userData.id,
              createdTimestamp: 0,
              username: userData.username,
              enabled: true,
              totp: true,
              emailVerified: true,
              firstName: userData.firstName,
              lastName: userData.lastName,
              email: userData.email,
              disableableCredentialTypes: [
                null
              ],
              requiredActions: [
                null
              ],
              notBefore: 0,
              access: {
                manageGroupMembership: true,
                view: true,
                mapRoles: true,
                impersonate: true,
                manage: true
              }
            },
            userCredentials: {
              type: "password",
              value: userData.password,
              temporary: true
            },
            changeRoleRequest: {
              clientRole: {
                oldRoles: oldClientRoleData.length !== 0 ? [{
                    id: oldClientRoleData.id,
                    name: oldClientRoleData.name,
                    composite: oldClientRoleData.composite,
                    clientRole: oldClientRoleData.clientRole,
                    containerId: oldClientRoleData.containerId
                }] : [],
                newRoles: clientRoleData.length !== 0 ? [{
                    id: clientRoleData.id,
                    name: clientRoleData.name,
                    composite: clientRoleData.composite,
                    clientRole: clientRoleData.clientRole,
                    containerId: clientRoleData.containerId
                }] : []
              },
              realmRole: {
                oldRoles: oldRealmRoleData.length !== 0 ? [{
                    id: oldRealmRoleData.id,
                    name: oldRealmRoleData.name,
                    composite: oldRealmRoleData.composite,
                    clientRole: oldRealmRoleData.clientRole,
                    containerId: oldRealmRoleData.containerId
                }] : [],
                newRoles: realmRoleData.length !== 0 ? [{
                    id: realmRoleData.id,
                    name: realmRoleData.name,
                    composite: realmRoleData.composite,
                    clientRole: realmRoleData.clientRole,
                    containerId: realmRoleData.containerId
                }] : []
              }
            }
        }
    }

    private convertResponseData(data: any): IUserViewData {
        return new UserViewData(data.id, data.firstName, data.lastName, data.displayName, data.email, data.userName, data.role, data.languagePreferred, data.description, data.reportTemplate,data.isEnabled);
    }

}

const userActions = new UserActions();
export default userActions;